export type Contact = Nullable<{
  email: string
  phone: string
}>

function load(model?: Partial<Contact> | null): Contact {
  return {
    email: model?.email ?? null,
    phone: model?.phone ?? null,
  }
}

export const Contact = {
  load,
}
